import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';

const getUrlToAdd = (companyId?: string) =>
  companyId
    ? getEndpointV2({ path: '/auth/company/:companyId/register_carrier', urlParams: { companyId } })
    : getEndpointV2({ path: '/auth/company/register_carrier' });

const getUrlToRemove = (id: string, companyId?: string) =>
  companyId
    ? getEndpointV2({
        path: '/auth/company/:companyId/carrier/:id',
        urlParams: { companyId, id },
      })
    : getEndpointV2({ path: '/auth/company/carrier/:id', urlParams: { id } });

/**
 * ADD
 */

type PayloadAdd = {
  data: Record<string, unknown>;
  companyId?: string;
};

export const carriersAdd = createApiSlice<unknown, PayloadAdd>({
  name: 'carriersAdd',
  *tryGenerator(_, { payload: { data, companyId } }) {
    yield call(amplifyClient, {
      method: 'post',
      url: getUrlToAdd(companyId),
      data,
    });

    return null;
  },
});

/**
 * REMOVE
 */

type PayloadRemove = {
  id: string;
  companyId?: string;
};

export const carrierRemove = createApiSlice<unknown, PayloadRemove>({
  name: 'carrierRemove',
  *tryGenerator(_, { payload: { id, companyId } }) {
    yield call(amplifyClient, {
      method: 'del',
      url: getUrlToRemove(id, companyId),
    });

    return null;
  },
});
